import { render, staticRenderFns } from "./GreenWasteForm.vue?vue&type=template&id=d038e4e2&scoped=true&"
import script from "./GreenWasteForm.vue?vue&type=script&lang=js&"
export * from "./GreenWasteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d038e4e2",
  null
  
)

export default component.exports